<template>
  <div class="text-center">
    <img
      src="https://cdnsae.mineduc.cl/logos/Logo10.png"
      class="img-fluid d-block mt-1 mb-2 mt-lg-2"
      alt=""
    />
  </div>
</template>

<script>
export default {};
</script>



// WEBPACK FOOTER //
// src/components/generales/modales/Cargando.vue